import UbsApiV2 from "./UbsApiV2";

export const getLocationByUuidApi = async (uuid) => {
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await UbsApiV2.get(`/ssc/locations/${uuid}`, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      let errRes = {};
      if (err.response !== undefined) {
        errRes = err.response;
      } else {
        errRes = "Network error";
      }
      return errRes;
    });
  return response;
};

export const getLocations = async () => {
  const headers = {
    "Content-Type": "application/json",
  };
  const response = await UbsApiV2.get(`/ssc/locations`, {
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      let errRes = {};
      if (err.response !== undefined) {
        errRes = err.response;
      } else {
        errRes = "Network error";
      }
      return errRes;
    });
  return response;
};
